import React from 'react';
import { Link } from 'react-router-dom';
import { useScript } from '../context/ScriptContext';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const CookiePolicyPage: React.FC = () => {
  const { t } = useScript();
  useDocumentTitle(t('Колачићи') + ' — ' + t('Манастир Градац'), '/kolacici');

  return (
    <div className="legal-page">
      <div className="legal-page-inner">
        <Link to="/" className="legal-back-link">{t('← Назад')}</Link>
        <h1 className="legal-page-title">{t('Политика колачића')}</h1>
        <p className="legal-page-updated">{t('Последње ажурирање')}: 07. јул 2026.</p>

        <section className="legal-section">
          <h2>{t('Шта су колачићи?')}</h2>
          <p>
            {t('Колачићи (cookies) су мале текстуалне датотеке које веб-сајт чува на Вашем уређају (рачунару, телефону или таблету) приликом посете. Они омогућавају да веб-сајт запамти Ваше поставке и преференце.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Које колачиће користимо?')}</h2>
          
          <h3>{t('Неопходни колачићи')}</h3>
          <p>{t('Ови колачићи су неопходни за основно функционисање веб-сајта. Без њих, сајт не може да функционише исправно.')}</p>
          <ul>
            <li><strong>{t('Језичке преференце')}</strong> — {t('Чува Ваш избор језика/писма (ћирилица, латиница, енглески итд.).')}</li>
          </ul>

          <h3>{t('Аналитички колачићи')}</h3>
          <p>{t('Ови колачићи нам помажу да разумемо како посетиоци користе наш веб-сајт, што нам омогућава да побољшамо његову функционалност и садржај.')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('Управљање колачићима')}</h2>
          <p>
            {t('Можете подесити свој претраживач да одбије све колачиће или да Вас обавести када се колачић шаље. Имајте у виду да неке функције веб-сајта можда неће радити исправно ако онемогућите колачиће.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Колачићи трећих страна')}</h2>
          <p>
            {t('Наш веб-сајт може садржати садржај или услуге трећих страна (нпр. Google Maps за приказ локације манастира) који могу постављати сопствене колачиће. Ми немамо контролу над колачићима трећих страна.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Правни основ')}</h2>
          <p>
            {t('Коришћење колачића је у складу са Законом о заштити података о личности Републике Србије („Сл. гласник РС", бр. 87/2018) и Законом о електронским комуникацијама.')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
